// jQuery as a global for the app code, the inline scripts in the views and the jQuery plugins.
// Kept in its own module so the assignment runs before the plugins load.
import jQuery from "jquery"

window.$ = window.jQuery = jQuery
